var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"orderList"},_vm._l((_vm.groupedOrders),function(dateGroup){return _c('div',{key:dateGroup.date},[_c('OrderDateGroup',_vm._b({},'OrderDateGroup',dateGroup,false))],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }